import { useQuery } from '@tanstack/react-query';
import { fetchOperatorOffersByRefNumber } from 'api/requests/requests';
import { STALE_FIVE_MINUTES } from 'api/types';

export const offersQueryKeys = {
  all: ['offers'] as const,
  offers: (refNumber: String) => [...offersQueryKeys.all, refNumber, 'operator-offers'] as const,
};

export function useOperatorOffersByRefNumberQuery(refNumber: string) {
  return useQuery({
    queryKey: offersQueryKeys.offers(refNumber),
    queryFn: () => fetchOperatorOffersByRefNumber(refNumber),
    staleTime: STALE_FIVE_MINUTES,
    select: ({ data }) => data,
  });
}
